import React, { useState } from 'react';
import { Box, Paper, Typography, TextField, Button, Switch, FormControlLabel, Alert } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { createNotice } from '../../lib/notices';

const NoticeInputForm = ({ onSuccess }) => {
  const { user, isAdmin } = useAuth();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [isPinned, setIsPinned] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  if (!isAdmin) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!title.trim() || !content.trim()) {
      setError('제목과 내용을 모두 입력하세요.');
      return;
    }
    setLoading(true);
    try {
      await createNotice({ title, content, isPinned });
      setSuccess('공지사항이 등록되었습니다.');
      setTitle('');
      setContent('');
      setIsPinned(true);
      if (onSuccess) onSuccess();
    } catch (err) {
      setError('공지사항 등록 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={4} sx={{ p: 4, mb: 4, borderLeft: '6px solid', borderColor: 'primary.main', background: 'rgba(33, 150, 243, 0.04)' }}>
      <Typography variant="h5" fontWeight={700} color="primary.main" gutterBottom>
        📢 공식 공지사항 등록
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        마크다운 지원, 공식적이고 권위 있는 안내만 등록하세요.
      </Typography>
      <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label="제목"
          value={title}
          onChange={e => setTitle(e.target.value)}
          required
          fullWidth
        />
        <TextField
          label="본문 (마크다운 지원)"
          value={content}
          onChange={e => setContent(e.target.value)}
          required
          fullWidth
          multiline
          minRows={10}
        />
        <FormControlLabel
          control={
            <Switch
              checked={isPinned}
              onChange={e => setIsPinned(e.target.checked)}
              color="primary"
            />
          }
          label="상단 고정(공지)"
        />
        {error && <Alert severity="error">{error}</Alert>}
        {success && <Alert severity="success">{success}</Alert>}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button type="submit" variant="contained" color="primary" disabled={loading}>
            {loading ? '등록 중...' : '공지 등록'}
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default NoticeInputForm;
